import { useMemo } from 'react';
import { ADMIN, BRISTEC_ADMIN, MODERATOR } from '../../../const/constants';
import { useAuth } from '../../../hooks/useAuth';
import type { RearDisplayDto } from '../types/RearDisplayDto';

export function useIsModeratable(rearDisplay: RearDisplayDto) {
	const auth = useAuth();

	const disabledMessage = useMemo(() => {
		if (![MODERATOR, ADMIN, BRISTEC_ADMIN].includes(auth.getRole()))
			return 'You do not have the required permissions';
		if (rearDisplay.moderatedBy) return 'Rear Display has been moderated';
	}, [rearDisplay.moderatedBy]);

	return disabledMessage;
}
